module.exports = __webpack_public_path__ + "img/UNA-SE.dafb6af9.png";